module.exports = __webpack_public_path__ + "static/media/ads (1).b9be4010.png";